import { DependencyList, useEffect } from 'react';

/**
 * Seeds a dialog's form from the order when the dialog opens, and only then (DD-3231). The
 * order a dialog receives is live: a mutation anywhere or an ORDER_CHANGED event re-renders
 * it, so seeding on every order change would reset what the user is typing. The next open
 * picks up the latest values. `deps` re-seed while open for data the form waits on (e.g.
 * client settings that load after the dialog opens).
 */
export const useSeedOnOpen = (open: boolean, seed: () => void, deps: DependencyList = []) => {
    useEffect(() => {
        if (open) {
            seed();
        }
    }, [open, ...deps]);
};
